<template>
  <div class="memberCenter_wrap ChangeInform" :style="{ height: height }">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><router-link to="/MemberCenter">首页</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>我要报价</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 	<div class="back_btn" @click="back">
				返回
				<img src="@/assets/img/icon_return.png" alt />
			</div> -->
    </div>
    <EditProduct v-if="currentStep == 0" :product="product" :settleMethods="settleMethods" :supplierInfo="supplierInfo" @reload="getData"></EditProduct>
    <EditQuotation v-if="currentStep == 1" :offerIds="offerIds" :currentStep.sync="currentStep"></EditQuotation>
  </div>
</template>

<script>
import EditProduct from '@/views/InQuiryPrice/EditProducts.vue'
import EditQuotation from '@/views/InQuiryPrice/EditQuotation.vue'
export default {
  components: { EditProduct, EditQuotation },
  data() {
    return {
      detailIds: this.$route.query.detailIds,
      currentStep: 0,
      offerIds: '',
      dataList: [],
      savePath: '',
      businessType: 0,
      uploadUrl: '',
      settleMethods: [],
      contact: '',
      phone: '',
      product: {
        dataList: []
      },
      supplierInfo: {
        Contact: '',
        Phone: '',
        Address: '',
        Email: ''
      },
      height: '0px'
    }
  },
  mounted() {
    let change_inform = document.getElementsByClassName('MemberHeader')[0]
    this.height = window.innerHeight - change_inform.clientHeight - 17 + 'px'
    this.getData(false)
  },
  methods: {
    back() {
      history.go(-1)
    },
    getData(flag) {
      let config = {
        params: {
          detailIds: this.detailIds
        }
      }
      console.log(flag)
      this.getRequest('/InQuiryPrice/EditOffers', config).then((res) => {
        if (res.data.errcode == 0) {
          this.product.dataList = res.data.dataList
          this.settleMethods = res.data.settleMethods
          this.supplierInfo.Contact = res.data.contact
          this.supplierInfo.Phone = res.data.phone
          this.supplierInfo.Address = res.data.address
          this.supplierInfo.Email = res.data.email
          this.offerIds = res.data.offerIds
          window.localStorage.setItem('sysNo', res.data.sysNo)
          if (flag) this.currentStep = 1
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;
  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}
.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;
    .el-input {
      width: 200px;
    }
  }
  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }
  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }
  .el-input {
    width: 300px;
    margin-right: 8px;
  }
  .businessTermEndDate {
    margin-bottom: 0 !important;
    .el-input {
      width: 100% !important;
    }
    .el-form-item__label:before {
      display: none;
    }
    .el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}
.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;
  .product_form {
    margin-bottom: 0;
  }
  .table_1 {
    width: 100%;
    margin: 0;
  }
  .table_1 tr td {
    border-right: none;
    border-bottom: none;
    text-align: center;
  }
}
.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}
.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;
    .el-range-input {
      font-size: 14px;
    }
  }
}
.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;
    .el-tree-node {
      display: inline-block;
    }
  }
}
.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}
.width_full {
  width: 100% !important;
}
</style>
